import PinList from "@/components/PinList";
import { getFavoritePins } from "@/services";
import useRequest from "@/utils/useReq";
import { useSetState } from "ahooks";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import styles from "./index.module.less";

export default function FavoritePinList({ serverPinList }) {
  const router = useRouter();
  const { urlname } = router.query;

  const [query, setQuery] = useSetState({
    max: serverPinList?.length
      ? serverPinList[serverPinList.length - 1]?.seq ||
        serverPinList[serverPinList.length - 1]?.pin_id
      : 0,
    urlname: null,
  });
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState(serverPinList || []);

  const initRef = useRef(!serverPinList);
  useRequest(
    async () => {
      const { max, urlname } = query;
      if (!urlname) {
        return;
      }

      const result = await getFavoritePins({
        urlname,
        limit: 20,
        ...(max ? { max } : null),
      });

      const pins = result?.pins || [];

      if (pins.length <= 0) {
        setHasMore(false);
      }

      setDataSource(dataSource.concat(pins));
    },
    {
      refreshDeps: [query],
    }
  );

  useEffect(() => {
    if (urlname) {
      setHasMore(true);
      if (initRef.current) {
        setDataSource([]);
        setQuery({
          urlname,
          max: 0,
        });
      } else {
        initRef.current = true;
        setQuery({
          urlname,
        });
      }
    }
  }, [urlname, setQuery]);

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      const last = dataSource[dataSource.length - 1];
      setQuery({
        max: last.seq || last.pin_id,
      });
    }
  }, [dataSource, setQuery]);

  return (
    <div className={styles.pin}>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          <PinList
            dataSource={dataSource}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
          />
        </Then>
        <Else>
          <div className={styles.empty}>暂无采集</div>
        </Else>
      </If>
    </div>
  );
}
